
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for-schools",
      function () {
        return require("private-next-pages/for-schools/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/for-schools"])
      });
    }
  